module.exports = __webpack_public_path__ + "img/carbon@2x.d214df3.jpg";